import { Button, Grid, Hidden, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { SIDE_PADDING, TOP_PADDING } from "../../app/theme/muiTheme";

const usestyles = makeStyles((theme) => ({
  root: {
    paddingTop: "5%",
  },
  bloglabeltxt: {
    fontSize: 25,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  blogDatetxt: {
    fontSize: 18,
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  blogdurationtxt: {
    fontSize: 18,
    fontWeight: "normal",
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  headingtxt: {
    fontSize: 30,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  categoryWrapper: {
    fontSize: 18,
    fontFamily: theme.typography.fontFamily,
    color: theme.typography.allVariants.color,
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  categorytext: {
    fontWeight: "normal",
    backgroundColor: theme.palette.secondary.light,
    padding: "1% 2% 1% 2%",
    borderRadius: 5,
  },
  shortdesctxt: {
    fontSize: 18,
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  publishedbytext: {
    fontSize: 18,
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  playbutton: {
    position: "absolute",
    left: "40%",
    top: "40%",
    "&:hover": {
      cursor: "pointer",
    },
  },
  image: {
    width: "100%",
  },
  subroot: {
    [theme.breakpoints.down("md")]: {
      paddingLeft: SIDE_PADDING,
      paddingBottom: TOP_PADDING,
    },
  },
}));

const VlogCard = (props) => {
  const classes = usestyles();

  return (
    <Grid container className={classes.root} justifyContent="space-between">
      <Grid item xs={12} md={2} className={classes.subroot}>
        <Typography className={classes.bloglabeltxt}>Vlogs ____</Typography>
        <br />
        <Typography className={classes.blogDatetxt}>
          {moment(_.get(props, ["data", "updatedAt"])).format("MMM Do YYYY")}
          <Hidden mdUp>
            {" "}
            <span className={classes.blogdurationtxt}>
              {_.get(props, ["data", "time"])}
            </span>
          </Hidden>
        </Typography>
        <Hidden mdDown>
          <Typography className={classes.blogdurationtxt}>
            {_.get(props, ["data", "time"])}
          </Typography>
        </Hidden>
      </Grid>
      <Grid item xs={12} md={4} className={classes.subroot}>
        <Typography className={classes.headingtxt}>
          {_.get(props, ["data", "title"])}
        </Typography>
        <br />

        <br />
        <Typography className={classes.publishedbytext}>
          {_.get(props, ["data", "published_by"])}
        </Typography>
        <br />
        <Hidden mdDown>
          <Button
            onClick={() => {
              window.open(_.get(props, ["data", "url"]), "_blank");
            }}
            startIcon={<img src="/images/watchnowlefticon.svg" alt="fb" />}
          >{`Watch Now ->`}</Button>
        </Hidden>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        style={{
          position: "relative",
        }}
      >
        <video
          preload="metadata"
          src={`${_.get(props, ["data", "url"])}#t=0.1`}
          className={classes.image}
          controls={true}
        />
      </Grid>
    </Grid>
  );
};

export default VlogCard;
